<template>
    <div>

        <div class="row text-center">
            <h5 class="col-12 w-100 text-center mt-3">
                کاربر گرامی فقط میتوانید سال مالی هایی که تاریخ آنها گذشته است را ببندید و حسابهای افتتاحیه به سال مالی فعلی که به تاریخ روز است ایجاد میشوند.
            </h5>
        </div>
        <hr/>

        <div class="row">
            <div class="col-lg-6 my-2">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">سال مالی را انتخاب کنید</span>
                    </div>
                    <vs-select :data="saleMalis" :mode="'create'"
                               :selected-val="selectedSalemali"
                               :header="{multiple: false, label: 'name'}"
                               @onChange="selectSalemali"></vs-select>
                </div>
            </div>
            <div class="col-lg-6 my-2" v-if="showCalculate">
                <button class="btn btn-success" @click="onCheckAccountsClicked">چک کردن حسابها</button>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div class="col-12">
                <div v-if="problemAccounts.length<=0" class="w-100 text-center">
                    <span v-if="noError">خطایی یافت نشد</span>
                </div>
                <div v-else class="table-responsive">
                    <table class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th class="text-center text-nowrap">کد حساب</th>
                            <th class="text-center text-nowrap">نام حساب</th>
                            <th class="text-center text-nowrap">نوع مانده</th>
                            <th class="text-center text-nowrap">جمع بدهکار</th>
                            <th class="text-center text-nowrap">جمع بستانکار</th>
                            <th class="text-center text-nowrap">اختلاف مانده</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in problemAccounts">
                            <td class="text-center">{{item.accountCode}}</td>
                            <td class="text-center">{{item.accountName}}</td>
                            <td class="text-center">{{item.totalDebp < item.totalCredit ? "بدهکار" : "بستانکار"}}</td>
                            <td class="text-center">{{item.totalDebp.toLocaleString()}}</td>
                            <td class="text-center">{{item.totalCredit.toLocaleString()}}</td>
                            <td class="text-center">{{item.totalRemain.toLocaleString()}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!---------------------- بستن هزینه و درآمد ------------------------------>
        <hr/>
        <div class="row">
            <div class="col-lg-6 mt-2" v-if="noError">
                <button class="btn btn-success text-center w-100 " @click="onCloseBenefitClicked">بستن حسابهای هزینه و درآمد و محاسبه سود و زیان</button>
            </div>
            <div class="col-lg-3 mt-2" v-if="benefit.accountName !== undefined">
                <button class="btn btn-warning text-center w-100" @click="onCloseOtherClicked">بستن سایر حسابها</button>
            </div>
            <div class="col-lg-3 mt-2" v-if="otherClosed">
                <button class="btn btn-danger text-center w-100" @click="onCloseTotalClicked">بستن این سال مالی</button>
            </div>
            <div class="col-lg-12 my-2 table-responsive" v-if="benefit.accountName !== undefined">
                <table class="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th class="text-center text-nowrap">نام حساب</th>
                        <th class="text-center text-nowrap">کد حساب</th>
                        <th class="text-center text-nowrap">جمع بدهکار</th>
                        <th class="text-center text-nowrap">جمع بستانکار</th>
                        <th class="text-center text-nowrap">سود</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="text-center">{{benefit.accountName}}</td>
                        <td class="text-center">{{benefit.accountCode}}</td>
                        <td class="text-center">{{benefit.totalDebp.toLocaleString()}}</td>
                        <td class="text-center">{{benefit.totalCredit.toLocaleString()}}</td>
                        <td class="text-center">{{benefit.totalRemain.toLocaleString()}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!---------------------- بستن سایر حسابها ------------------------------>


        <!---------------------- MODALS ------------------------------>


    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"
    import VueHtmlToPaper from 'vue-html-to-paper';
    import html2canvas from 'html2canvas';
    import axios from "axios";
    import Constants from "../../Constants";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'sellFactors',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {

                saleMalis: [],
                selectedSalemali: {},
                showCalculate: false,
                isLoading: false,
                noError: false,
                otherClosed: false,
                problemAccounts: [],
                benefit: {},
            }
        },
        mounted() {
            $("#loading").hide();
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            this.getsalemali();
        },
        methods: {
            getsalemali() {
                new BaseService('account', '/Getsalemali').getList().then(response => {
                    if (response.data !== null && response.data !== "") {
                        this.saleMalis = response.data.value;
                    }
                    if (this.saleMalis.length > 0) {
                        for (let item of this.saleMalis) {
                            item.fstartDate = Moment(item.startDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                            item.fendDate = Moment(item.endDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            selectSalemali(val) {
                if (val && val.id) {
                    this.selectedSalemali = val;
                    let tod = Moment(new Date()).format('YYYY-MM-DD');
                    val.start = Moment(val.startDate).format('YYYY-MM-DD');
                    val.end = Moment(val.endDate).format('YYYY-MM-DD');

                    if (val.start < tod && val.end < tod) {
                        if (val.closed) {
                            this.showCalculate = false;
                            this.$noty.error("سال مالی قبلا بسته شده است");
                        } else {
                            this.showCalculate = true;
                        }
                    } else {
                        this.showCalculate = false;
                        this.$noty.error("سال مالی بایستی خارج از سال مال جاری باشد");
                    }
                }
            },
            onCheckAccountsClicked() {
                $("#loading").show();
                this.problemAccounts = [];
                this.noError = false;
                new BaseService('Voucher', `/ChechForClose/${this.selectedSalemali.id}`).getList().then(response => {
                    console.log(response)
                    if (response.data !== null && response.data.data.length > 0) {
                        this.problemAccounts = response.data.data;
                        console.log(this.problemAccounts)
                    } else {
                        this.noError = true;
                    }
                    $("#loading").hide();
                }).catch(error => {
                    console.log(error)
                    this.$noty.error(error.data.message)
                    $("#loading").hide();
                });
            },
            onCloseBenefitClicked() {
                $("#loading").show();
                this.benefit = {};
                new BaseService('Voucher', `/CloseBenefit/${this.selectedSalemali.id}`).getList().then(response => {
                    console.log(response);
                    this.$noty.success(response.data.message);
                    if (response.data !== null) {
                        this.benefit = response.data.data;

                    }
                    $("#loading").hide();
                }).catch(error => {
                    console.log(error)
                    this.$noty.error(error.data.message);
                    $("#loading").hide();
                });

            },
            onCloseOtherClicked() {
                $("#loading").show();
                this.otherClosed = false;
                new BaseService('Voucher', `/CloseOther/${this.selectedSalemali.id}`).getList().then(response => {
                    console.log(response);
                    this.$noty.success(response.data.message);
                    this.otherClosed = true;
                    // if (response.data !== null ) {
                    //     this.benefit = response.data.data;
                    //
                    // }
                    $("#loading").hide();
                }).catch(error => {
                    console.log(error)
                    this.$noty.error(error.data.message);
                    $("#loading").hide();
                });
            },
            onCloseTotalClicked() {
                $("#loading").show();
                this.otherClosed = false;
                new BaseService('Voucher', `/CloseTotal/${this.selectedSalemali.id}`).getList().then(response => {
                    console.log(response);
                    this.$noty.success(response.data.message);

                    this.problemAccounts = [];
                    this.noError = false;
                    this.benefit = {};
                    this.otherClosed = false;
                    this.showCalculate = false;
                    this.selectedSalemali.name="";
                    this.getsalemali();

                    $("#loading").hide();
                }).catch(error => {
                    console.log(error)
                    this.$noty.error(error.data.message);
                    $("#loading").hide();
                });
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                if ($("#voucherDataEdit").hasClass("show")) {
                    $("#voucherDataEdit").modal("hide");
                    next(false);
                } else {
                    next();
                }
            }


        },
    }
</script>